export default __webpack_public_path__ + "static/media/calendar.67d4d30e.svg";